var _ellipse, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabletFluentMdl2DocumentApproval(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 56,
    viewBox: "0 0 60 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.5,
    cy: 38.3975,
    rx: 23.5,
    ry: 8,
    fill: "#D5EEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_620_660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.1992,
    y: 30.5176,
    width: 25.9,
    height: 10.56,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6753 32.8101L36.1562 41.8013L31.5591 37.4507L33.0972 36.0005L36.1562 38.8687L44.1372 31.3599L45.6753 32.8101ZM30.6875 19.71V11.46H15.375V40.335H30.6875V42.3975H13.1875V9.39746H32.2427L41.625 18.2437V30.0225L39.4375 32.085V19.71H30.6875ZM32.875 17.6475H37.8823L32.875 12.9263V17.6475Z",
    fill: "#0593F5",
    stroke: "#D5EEFF",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_620_660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 33,
    fill: "white",
    transform: "translate(11 9.39746)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletFluentMdl2DocumentApproval);
export default __webpack_public_path__ + "static/media/tablet-fluent-mdl2_document-approval.47e524398bb1f154288847c7b53763de.svg";
export { ForwardRef as ReactComponent };